module.exports = __webpack_public_path__ + "static/media/iconAlert_cancel.32a6d743.svg";